import { render, staticRenderFns } from "./CreateComputedParam.vue?vue&type=template&id=0b39fe8b&scoped=true"
import script from "./CreateComputedParam.vue?vue&type=script&lang=js"
export * from "./CreateComputedParam.vue?vue&type=script&lang=js"
import style0 from "./CreateComputedParam.vue?vue&type=style&index=0&id=0b39fe8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39fe8b",
  null
  
)

export default component.exports